<template>
  <div class="scroll-container" @click="showSearchSelect = false">
    <IndexHeader />
    <div class="all_container">
      <div class="box ">

        <div class="container">

          <Nav2 @selectSearch="selectSearch" :sign="1">
            <div class="head-top-search fx">
              <div class="top-search">

                <span class="search-l" @click.stop="showSearchSelect = !showSearchSelect">{{ selectList[search] }}</span>
                <i :class="showSearchSelect ? 'el-icon-caret-top icon-down' : 'el-icon-caret-bottom icon-down'"></i>
                <ul v-if="showSearchSelect" class="search-select-list">
                  <li v-for="(item, index) in selectList" @click.stop="selectSearch(index)">{{ item }}</li>
                </ul>
                <input type="text" class="search-input" v-model="searchInput" placeholder="请输入检索词">
                <i class="el-icon-close icon-close" @click="clearSearch" v-if="searchInput != ''"></i>
                <button class="search-btn" @click="toHigh"><i class="el-icon-search"></i></button>
              </div>
              <div class="high-search" @click="toHigh">高级搜索 <i class="el-icon-arrow-right"></i></div>
            </div>
          </Nav2>
        </div>
      </div>
      <div class="box top">

        <div>

          <div class="swiper-box">
            <!-- <img src="../../assets/images/banner-1.png" alt=""> -->
            <swiper ref="mySwiper" :options="swiperOptions" v-if="showBanner">
              <swiper-slide v-for="item in bannerList" :key="item.id" :data-content="item.content"
                :data-url="item.source">
                <img :data-content="item.content" :data-sid="item.id" :data-url="item.source" class="swiper-img"
                  :src="$config.baseImgURL + 'Article/showPhotograph/' + item.surfacePlot" alt="">
              </swiper-slide>

            </swiper>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
            <div class="swiper-pagination fx" slot="pagination"></div>

          </div>

        </div>
      </div>
      <div class="box notice-box">
        <!-- <div class="notice-bg">
        <img src="../../assets/images/notice-bg.png" alt="">
      </div> -->
        <!-- 滚动公告 -->
        <div class="container">
          <!-- <div class="search-box">
          <Search :showLeft="false" />
        </div> -->
          <div class="notice-scroll">
            <i class="el-icon-message-solid notice-icon"></i>
            <marquee behavior="scroll" direction="left" onmouseover="this.stop()" onmouseout="this.start()">
              <div class="notice-scroll-list">
                <span @click="$router.push({ path: `newsDetail?id=${item.id}` })" v-for="item in scrollList"
                  :key="item.id">{{ item.title }}</span>
              </div>
            </marquee>
          </div>
        </div>
        <!-- 新闻 -->
        <div class="container mid">
          <div class="mod-title"><span>新闻中心</span>
            <el-link href="#/newsInfo" :underline="false"> 更多</el-link>
          </div>
          <!-- <div style="width:100%;border-bottom:2px solid #ccc;height:5px;margin-bottom:10px"></div> -->
          <el-row>
            <el-col :span="11">
              <!-- <img src="../../assets/images/news-1.png" class="news-img" alt=""> -->
              <div class="swiper-box2">
                <swiper ref="mySwiper2" :options="swiperOptions2" v-if="showSwiper1">
                  <swiper-slide v-for="item in bannerListBlock" :key="item.id">
                    <img :data-sid="item.id" class="swiper-img"
                      :src="$config.baseImgURL + 'Article/showPhotograph/' + item.surfacePlot" alt="">
                  </swiper-slide>

                </swiper>
                <div class="swiper-pagination2 fx" slot="pagination"></div>
              </div>
            </el-col>
            <el-col :span="12" :offset="1">
              <ul>
                <li @click="$router.push({ path: `newsDetail?id=${item.id}` })"
                  :class="index == 0 || index == 1 ? 'active' : ''" class="notice-item" v-for="(item, index) in newsList"
                  :key="index">
                  <div class="notice-item-fx fx" style="width:100%">
                    <div class="notice-item-text">{{ item.title }}</div>
                    <span>{{ $dayjs(item.lastModifyTime).format('YYYY-MM-DD') }}</span>
                  </div>

                </li>

              </ul>
            </el-col>
          </el-row>
        </div>
      </div>

      <div class="box mid-box">
        <div class="container mid-grid">
          <el-row>
            <el-col :span="6">
              <div>
                <div class="mid-grid-top mid-grid-top1"><span>下载排行</span></div>
                <div class="mid-rank-box">
                  <div class="fx">
                    <span>资源名称</span>
                    <span>下载数量</span>
                  </div>
                  <div class="school-scroll-box">
                    <ul class="school-scroll" :style="{ top: top + 'px' }">
                      <li @click="goDetail(item)" v-for="(item, index) in downloadList" :key="index"
                        class="school-item fx">
                        <div class="fx s_left">
                          <div :class="index < 3 ? 'rank-icon rank-red' : 'rank-icon'">{{ index + 1 }}</div>
                          <div class="title">{{ item.resourceName }}</div>
                        </div>
                        <div class="s_right">{{ item.downloads | filterNum }}</div>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="chart">
                  <div class="mid-grid-top mid-grid-top1"><span>资源库类别占比</span></div>
                  <div style="margin-bottom:20px;height:10px"></div>
                  <div class="echarts" ref="echarts"></div>
                </div>

              </div>
            </el-col>
            <el-col :span="18">
              <div class="mid-grid-item">
                <div class="fx mid-grid-top mid-grid-top2">
                  <span>精品资源</span>
                  <el-link href="#/resourceList?type=2" :underline="false">更多</el-link>
                </div>
                <div class="card-item card-item2">
                  <el-row>
                    <el-col :span="8" v-for="(item, index) in sourceList" :key="index">
                      <Card :cardStyle="cardStyle" :cardData="item" @toDetail="goDetail(item)" />
                    </el-col>
                  </el-row>

                </div>
              </div>

              <div class="mid-grid-item">
                <div class="fx mid-grid-top mid-grid-top2">
                  <span>热门资源</span>
                  <el-link href="#/resourceList?type=3" :underline="false">更多</el-link>
                </div>
                <div class="card-item card-item2">
                  <el-row>
                    <el-col :span="8" v-for="(item, index) in sourceList2" :key="index">
                      <Card :cardStyle="cardStyle" :cardData="item" @toDetail="goDetail(item)" />
                    </el-col>
                  </el-row>

                </div>
              </div>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
    <goTop :showContact="true" :targetBox="'.scroll-container'" />
    <Footer />
  </div>
</template>
<script>
import goTop from '@/components/goTop.vue'
import IndexHeader from '@/components/IndexHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Card from '@/components/Card.vue'
import Search from '@/components/Search.vue'
import Nav2 from '@/components/Nav2.vue'
import * as echarts from "echarts";
import { getInformationPicList, getInformationPiecePicList, getInformationList, getDownRanking, getIndexList, getSchoolResourceProportion } from "@/utils/api"
export default {
  components: {
    Header,
    Footer,
    Card,
    Search,
    Nav2,
    IndexHeader,
    goTop
  },
  data(vm) {
    return {
      selectList: ['资源名称', '作者', '关键词'],
      showSearchSelect: false,
      searchInput: '',
      search: 0,
      bannerList: [],
      bannerListBlock: [],
      currentPage: 1,
      pageSize: 6,
      scrollList: [],
      newsList: [],
      scrollTop: 0,
      cardStyle: {
        // border: '1px solid #ccc',
        padding: '10px',
        height: '140px',
        fontSize: '14px',
        cursor: 'pointer'
      },
      sourceList: [],
      sourceList2: [],
      downloadList: [],
      school2: [
        require('../../assets/images/school-logo.png'),
        require('../../assets/images/logo4.png'),
        require('../../assets/images/school-logo.png'),
        require('../../assets/images/logo4.png'),
      ],
      option: {
        title: {
          text: '资源库类别占比',
          // subtext: 'Fake Data',
          left: 'center'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          show: false
        },
        series: [
          {
            name: '资源库',
            type: 'pie',
            radius: '50%',
            data: [],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      },
      swiperOptions: {
        loop: true,
        autoplay: {
          delay: 3000
        },

        pagination: {
          el: '.swiper-pagination',
          // type: 'custom',
          clickable: true
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
        ,
        on: {
          click: function (e) {
            if (e.srcElement.dataset.url || e.srcElement.dataset.content) {
              if (e.srcElement.dataset.url) {
                window.open(e.srcElement.dataset.url)
              } else {
                vm.$router.push(`/newsDetail?id=${e.srcElement.dataset.sid}&from=1`)
              }
            }

          }
        },
      },
      swiperOptions2: {
        loop: true,
        autoplay: {
          delay: 4000
        },
        pagination: {
          el: '.swiper-pagination2',
          // type: 'custom',
          clickable: true
        },
        on: {
          click: function (e) {
            if (e.srcElement.dataset.sid) {
              vm.$router.push(`/newsDetail?id=${e.srcElement.dataset.sid}&from=1`)
            }

          }
        }
      },
      activeIndex: 0,
      thStyle: {
        color: '#333'
      },
      interval: null,
      top: '0'
    }
  },
  computed: {
    showBanner() {
      return this.bannerList.length
    },
    showSwiper1() {
      return this.bannerListBlock.length
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    swiper2() {
      return this.$refs.mySwiper2.$swiper;
    },
    schoolId() {
      return this.$store.getters.schoolId;
    }
  },
  watch: {
    schoolId: function () {
      this.initData()
      this.getIndexListM('competitive')
      this.getIndexListM('hot')
      // 获取通知公告
      this.getInformationList(1)
      // 获取新闻中心
      this.getInformationList(2)
    }
  },
  mounted() {

    window.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop
    })
    this.getIndexListM('competitive')
    this.getIndexListM('hot')

    this.initData()
    // 获取通知公告
    this.getInformationList(1)
    // 获取新闻中心
    this.getInformationList(2)
    this.interval = setInterval(() => {
      if (this.top <= -196) {
        this.top = 0
      } else {
        this.top -= 49
      }
    }, 2000)
  },
  beforeDestroy() {
    this.interval = null
  },
  methods: {
    initData() {
      // 获取下载排行
      getDownRanking({
        schoolId: this.schoolId
      }).then(res => {
        this.downloadList = res.data
      })
      getInformationPicList({ organizeId: this.schoolId, category: '新闻中心' }).then(res => {
        this.bannerList = res.data
      })
      getInformationPiecePicList({ organizeId: this.schoolId, category: '新闻中心' }).then(res => {
        this.bannerListBlock = res.data
      })

      getSchoolResourceProportion({
        schoolId: this.schoolId
      }).then(res => {
console.log(res.data)
        let chart = echarts.init(this.$refs.echarts)
        if (this.schoolId != '') {
          this.option.series[0].data = res.data
          chart.setOption(this.option)
        }

      })
    },
    goTop() {
      window.scrollTo({
        left: 0,
        top: 0,
        behavior: 'smooth'
      })
    },
    goDetail(params) {
      if (params.isLoginShow == 1) {
        if (!this.$store.getters.token) {
          this.$confirm('本资源必须登录才能查看, 是否登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.$router.push(`/login?id=${params.id}&from=1`)
          }).catch((err) => {
          })
        } else {
          this.$router.push({ path: `/resourceDetail?id=${params.id}` })
        }
      } else {
        this.$router.push({ path: `/resourceDetail?id=${params.id}` })
      }
    },
    toHigh() {

      this.$router.push(`/resourceList?from=index&t_type=${this.search}&i_keyword=${this.searchInput}`)
    },

    selectSearch(index) {
      this.search = index
      this.showSearchSelect = false
    },
    getIndexListM(category) {
      getIndexList({
        schoolId: this.schoolId,
        category: category
      }).then(res => {
        if (category == 'competitive') {
          this.sourceList = res.data
        } else {
          this.sourceList2 = res.data
        }
      })
    },
    getInformationList(sign) {
      getInformationList({
        organizeId: this.schoolId,
        category: sign == 1 ? '通知公告' : '新闻中心',
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }).then(res => {
        if (sign == 1) {
          this.scrollList = res.data.list
        } else {
          this.newsList = res.data.list
        }

      })
    },

    navClick(params) {
      if (params.href) {
        this.$router.push(params.href)
      }
    },
    clearSearch() {
      this.searchInput = ''
    },
    toDetail(params) {
      window.sessionStorage.setItem('sign', 0)

    }
  }
}
</script>
<style scoped>
.all_container {
  width: 1280px;
  margin: 0 auto;
}

.container {
  width: 1280px;
  margin-bottom: 0;
}

.head-top {
  padding: 23px 0;
}

.head-top-search {
  margin: 20px 0;
  justify-content: center;
}

.head-top2 {
  padding: 10px 0 20px;
}

.newsMore {
  text-align: right;
}

.head-top-box {
  overflow: hidden;
  align-items: flex-end;
}

.head-top-school h3 {
  font-size: 30px;
  padding-left: 15px;
  letter-spacing: 3px;
  color: #333;
}

.top-search {
  position: relative;
  width: 600px;
  height: 40px;
  line-height: 40px;
  background: #fff;
  border-radius: 40px;
  font-size: 14px;
  border: 1px solid #ccc;
}

.high-search {
  cursor: pointer;
  margin-left: 20px;
  font-size: 14px;
}

.search-l {
  position: absolute;
  left: 30px;
  width: 56px;
  text-align: center;
  cursor: pointer;
}

.icon-down {
  position: absolute;
  left: 90px;
  top: 50%;
  transform: translateY(-50%);
}

.search-select-list {
  width: 100px;
  /* height: 100px; */
  background: #fff;
  text-align: center;
  position: absolute;
  top: 30px;
  left: 6px;
  z-index: 10;
  padding: 10px 3px 3px;
}

.search-select-list li {
  line-height: 30px;
  cursor: pointer;
}

.search-select-list li:hover {
  background: #f5f5f5;
}

.search-input {
  height: 30px;
  width: 360px;
  position: absolute;
  left: 130px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  appearance: none;
  outline: none;
}

.search-input i {
  cursor: pointer;
}

.icon-close {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
}

.search-btn {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  color: #fff;
  outline: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 4px;
  border: 0;
  background: #007aff;
}

.head-nav-col {
  text-align: right;

}

/* .head-nav-col:last-child{
  text-align: right;
  margin-left: -5px;
} */
.head-nav {
  white-space: nowrap;
  font-size: 16px;
  padding: 3px 10px;
  position: relative;
}

.head-nav:hover.head-nav {
  color: #fff;
}

.head-nav:hover.head-nav::after {
  top: -10px;
  color: #fff;
}

.head-nav::after {
  content: '';
  width: 100%;
  height: 50px;
  background: #1E7DE8;
  border-radius: 10px 10px 0 0;
  position: absolute;
  top: 150%;
  left: 0;
  z-index: -1;
  transition: all .3s;
}

.head-nav-active {
  color: #fff !important;
}

.head-nav-active::after {
  top: -10px;
  color: #fff;
}

.head-logo {
  cursor: pointer;
}

.swiper-box,
.swiper-box2 {
  height: 441px;
  overflow: hidden;
  position: relative;
}

.swiper-box2 {
  height: 339px;
}

.swiper-box img {
  width: 100%;
}

.search-box {
  height: 130px;
  padding-top: 1px;
  background: linear-gradient(to right, #3191f8, #1a79e5, #015cce);
}

.mid {
  margin: 15px auto;
}

.notice-top {
  font-size: 16px;
  line-height: 40px;
  font-weight: bold;
  color: #0e6ad9;
  margin-bottom: 15px;
  background: linear-gradient(to right, #e9e9e9, #e9e9e9, #fafafa);
}

.notice-scroll {
  font-size: 14px;
  margin: 10px 0 0;
  display: flex;
  align-items: center;


}

.notice-scroll-list span {

  margin-right: 50px;
  cursor: pointer;
}



.notice-icon {
  font-size: 12px;
  color: #fd962d;
  margin-right: 10px;
}

.notice-top i {
  font-size: 20px;
  padding: 0 18px;
}

.notice-main>ul {
  padding-left: 20px;
}

.notice-item {
  font-size: 16px;
  line-height: 51px;
  display: list-item;
  list-style: disc;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.notice-item:hover {
  background: #f5f5f5;
  color: red;
}

.notice-item-text {
  width: 85%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.active .notice-item-text {
  color: red;
}

.notice-item-fx span {
  align-self: flex-end;
}

.notice-right-box {
  width: 350px;
  height: 338px;
  border: 1px solid #f2f2f2;
  box-sizing: border-box;
  padding: 16px 0 26px 16px;
  position: relative;
}

.notice-right-top {
  height: 55px;
  border-bottom: 1px dotted #f2f2f2;
}

.notice-right-top>h3 {
  line-height: 16px;
  text-align: center;
  margin-left: 13px;
}

.notice-right-top>h3 p {
  font-size: 16px;
}

.notice-right-top>h3 span {
  font-size: 8px;
  font-weight: normal;
}

.notice-right-box li {
  font-size: 12px;
  line-height: 38px;
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.more {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 14px;
}

.mid-img-box {
  margin-bottom: 20px;
}

.mid-img {
  width: 100%;
}

.mid-section {
  margin: 0 auto 40px;
  justify-content: space-between;
}

.mid-item {
  width: 380px;
  height: 136px;
  border: 1px solid #f9e7e5;
  background: #f7efed;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 30px 70px;
  user-select: none;
}

.mid-item:nth-child(2) {
  background: #eaf4f3;
  border-color: #e2f5ef;
}

.mid-item:nth-child(3) {
  background: #f3f1f6;
  border-color: #ece3f4;
}

.mid-item img {
  width: 109px;
  height: 67px;
}

.mid-item-r {
  margin-left: 35px;
}

.mid-item-r h3 {
  color: #6b2822;
  margin-bottom: 20px;
}

.mid-item-r span {
  color: #7f5d6e;
  font-weight: bold;
}

.mid-grid-left {
  width: 589px;
}

.mid-rank-box {
  width: 92%;
  min-height: 371px;
  box-sizing: border-box;
}

.mid-rank-box>div:first-child {
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  line-height: 48px;
  border-bottom: 1px solid #ebeef5;
  padding: 0 5px;
}

.charts-img {
  width: 100%;
}

.mid-grid-top {
  justify-content: space-between;
  /* padding: 0 0 15px 5px; */
  border-bottom: 3px solid #2C8CF4;
  font-size: 18px;
  margin-bottom: 15px;
}

.mid-grid-top1 {
  width: 92%;
}

.mid-grid-top1 span {
  background: #2C8CF4;
  padding: 8px 17px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  display: inline-block;
}

.mid-grid-top2 span {
  background: #2C8CF4;
  padding: 8px 17px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
  display: inline-block;
}

.school-scroll-box {
  max-height: 294px;
  overflow: hidden;
}

.school-scroll {
  position: relative;
  transition: all .5s;
}

.school-item {
  justify-content: space-between;
  font-size: 14px;
  line-height: 48px;
  border-bottom: 1px solid #ebeef5;
  cursor: pointer;
  user-select: none;
  padding: 0 5px;
  color: #818181;
  box-sizing: border-box;

}

.school-item .s_left {
  width: 80%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.school-item .s_left .title {

  width: 85%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.school-item .s_right {
  width: 20%;
  text-align: right;
}

.school-item:nth-child(even) {
  background: #f5f5f5;
}

.school-item:hover {
  background: #eeeded;
}

.news-img {
  width: 100%;
  object-fit: cover;
}

.card-box {
  margin-bottom: 25px;
  user-select: none;
  width: 276px;
  height: 344px;
}

.card-img {
  width: 100%;
  height: 169px;
  display: block;
}

.card-item2 {
  padding-left: 16px;
}

.card-item-title {
  font-size: 18px;
  margin: 12px 0 15px;
}

.card-item-tips {
  height: 44px;
  font-size: 16px;
  color: #ccc;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.card-bottom {
  font-size: 16px;
}

.card-btn {
  padding: 3px 5px;
  background: #fd962d;
  border: none;
}

.school-title {
  justify-content: space-between;
  border-bottom: 1px solid #cbcbcb;
}

.school-title span {
  font-size: 18px;
  color: #686868;
  padding: 0 17px 18px;
  border-bottom: 2px solid #3191f8;
}

.school-card-box {
  justify-content: space-between;
}

.school-card {
  margin: 30px 0;
  width: 283px;
  height: 100px;
  box-shadow: 0 0 5px 2px rgba(0, 0, 0, .1);
  border-radius: 20px;
  justify-content: center;
}

.school-card img {
  width: 100%;
  border-radius: 20px;
}

.echarts {
  width: 100%;
  height: 300px;
}

.rank-icon {
  padding: 5px 7px;
  display: inline-block;
  border-radius: 5px;
  background: rgb(233, 139, 17);
  color: #fff;
  margin-right: 6px;
  line-height: 100%;
}

.rank-red {
  background: red;
}

.box {
  width: 100%;
}

.box.top {
  padding-bottom: 20px;
  /* background: linear-gradient(to bottom, #4572e3, #ccd8f3); */
}

.notice-box {
  position: relative;
  overflow: hidden;
}

.notice-bg {
  position: absolute;
  width: 100%;
  height: 100%;
  /* object-fit: contain; */
  z-index: -1;
  /* opacity: .5; */
  /* background: linear-gradient(to bottom, #0d1e70,#cdd4f3); */
  background-color: #a8d3fb;
}

.mid-box {
  padding: 26px 0 0;
  /* background: #d2d8f4; */
  position: relative;
  overflow: hidden;
}

.mid-box-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: .4;
}

.source-name {
  white-space: nowrap;
  display: inline-block;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
}

.swiper-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  cursor: pointer;
}

.swiper-container {
  height: 100%;
}

.swiper-box>>>.swiper-pagination {
  left: 50%;
  transform: translateX(-50%);
  bottom: 30px;
  width: 120px;
  padding: 7px 0;
  border-radius: 30px;
  align-items: center;
  justify-content: space-around;
}

.swiper-box>>>.swiper-pagination .swiper-pagination-bullet {
  background: #fff;
  opacity: 1;
  transition: all .5s;
  border-radius: 4px;
}

.swiper-box>>>.swiper-pagination .swiper-pagination-bullet-active {
  background: #007aff;
  width: 31px;
}

.swiper-pagination2 {
  position: absolute;
  z-index: 10;
  right: 0;
  bottom: 10px;
  width: 120px;
  padding: 7px 0;
  align-items: center;
  justify-content: space-around;
}

.swiper-pagination2>>>.swiper-pagination-bullet {
  background: #fff;
  opacity: 1;
  transition: all .5s;
  border-radius: 4px;
}

.swiper-pagination2>>>.swiper-pagination-bullet-active {
  background: #007aff;
  width: 31px;
}

.head-top-logo {
  height: 80px;
  justify-content: center;
}

.head-top-logo img {
  width: 80px;
  border-radius: 100%;
  margin-right: 20px;
}

.head-top-logo h3 {
  color: #333;
  font-size: 36px;
  letter-spacing: 4px;
}

.head-top-search {
  margin: 20px 0;
}

.top-search {
  position: relative;
  width: 600px;
  height: 40px;
  line-height: 40px;
  margin: auto;
  background: #fff;
  border-radius: 40px;
  font-size: 14px;
}

.search-l {
  position: absolute;
  left: 30px;
  width: 56px;
  text-align: center;
  cursor: pointer;
}

.icon-down {
  position: absolute;
  left: 90px;
  top: 50%;
  transform: translateY(-50%);
}

.search-select-list {
  width: 100px;
  /* height: 100px; */
  background: #fff;
  text-align: center;
  position: absolute;
  top: 30px;
  left: 6px;
  z-index: 10;
  padding: 10px 3px 3px;
}

.search-select-list li {
  line-height: 30px;
  cursor: pointer;
}

.search-select-list li:hover {
  background: #f5f5f5;
}

.search-input {
  height: 30px;
  width: 360px;
  position: absolute;
  left: 130px;
  top: 50%;
  transform: translateY(-50%);
  border: 0;
  appearance: none;
  outline: none;
}

.icon-close {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
}

.search-btn {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  color: #fff;
  outline: none;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 4px;
  border: 0;
  background: #007aff;
}

.menu {
  height: 40px;
  background: #2C8CF4;
  border-radius: 10px 10px 0 0;
  justify-content: space-around;
  overflow: hidden;
}

.menu-item {
  line-height: 40px;
  color: #fff;
  font-size: 16px;
  padding: 0 10px;
  flex: 1;
  text-align: center;
  cursor: pointer;
}

.menu-item:hover {
  background: #0662D3;
}

.menu-item.active {
  background: #0662D3;
}

.mod-title {
  border-bottom: 3px solid #2C8CF4;
  margin-bottom: 17px;
  display: flex;
  justify-content: space-between;
}

.mod-title span {
  background: #2C8CF4;
  padding: 8px 17px;
  color: #fff;
  font-weight: bold;
  font-size: 16px;
}
</style>